import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@material-ui/core";
import { useContext, useEffect, useRef } from "react";
import { UsersData } from "src/ContextAPI";
import GTCNewsFull from "src/GTCNewsFull";
import BhsVisits from "src/cis/components/BhsVisitis";
import ApprovedPatients from "src/cis/components/dashboard/ApprovedPatients";
import ListPatientHasDiseases from "src/cis/components/dashboard/ListPatientHasDiseases";
import Municipality from "src/cis/components/dashboard/Municipality";
import PatientCards from "src/cis/components/dashboard/PatientCards";
import LayoutContainer from "src/components/LayoutContainer";
import HealthUnitDetails from "./components/HealthUnitDetails";

const BhsDashboard = () => {
	const userContext = useContext(UsersData);
	const { users } = userContext;
	const name = users?.name;
	const receive_patient_ref = useRef(null);

	return (
		<LayoutContainer
			icon={<FontAwesomeIcon icon={faHome} color="white" size={"2x"} />}
			title={
				<Typography variant={window.innerWidth > 500 ? "h4" : "h5"}>
					Dashboard
				</Typography>
			}
			subtitle={`Welcome Back, ${name}! 👋`}
			titleChildren={<HealthUnitDetails />}
			className={`relative`}
		>
			<GTCNewsFull />
		</LayoutContainer>
	);
};

export default BhsDashboard;
